import React from "react";
// import {storage} from '../../../../_firebase'
// const maleImage = () => {
//   storage.child('placeholder/male.png').getDownloadURL().then(url=>{
//     return url;
//   })
// }
// const female = storage.child('placeholder/female.png')
const GenderSelect = ({ image }) => {
  return (
    <div className="row">
      <div className="col-xs-6 col-xs-offset-3">
        <div
          className="profile gender selected"
          style={{ marginBottom: "1em", cursor: "pointer" }}
        >
          <div className="profile-image tip">
            <img src={image} alt="male" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GenderSelect;



// WEBPACK FOOTER //
// ./src/_components/UI/MyInformation/GenderSelect/index.js